// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../utils/AvatarSrcUrl.bs.js");
let AgentInfo__Jsx3 = require("../../uikit/reason/atoms/AgentInfo/AgentInfo__Jsx3.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let SharedMessageCard = require("./SharedMessageCard.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let SharedPropertyMessage_sharedProperty_graphql = require("../../__generated__/SharedPropertyMessage_sharedProperty_graphql.bs.js");
let SharedPropertyMessage_AgentInfo_agent_graphql = require("../../__generated__/SharedPropertyMessage_AgentInfo_agent_graphql.bs.js");

let convertFragment = SharedPropertyMessage_AgentInfo_agent_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedPropertyMessage_AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedPropertyMessage_AgentInfo_agent_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedPropertyMessage_AgentInfo_agent_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SharedPropertyMessage_AgentInfo_agent_graphql.node, convertFragment, fRef);
}

let Fragment_membershipStatusV5_decode = SharedPropertyMessage_AgentInfo_agent_graphql.Utils.membershipStatusV5_decode;

let Fragment_membershipStatusV5_fromString = SharedPropertyMessage_AgentInfo_agent_graphql.Utils.membershipStatusV5_fromString;

let Fragment = {
  membershipStatusV5_decode: Fragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: Fragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function SharedPropertyMessage$AgentInfo$WithoutErrorBoundary(props) {
  let agent = RescriptRelay_Fragment.useFragment(SharedPropertyMessage_AgentInfo_agent_graphql.node, convertFragment, props.sharedProperty);
  let profilePhoto = agent.profilePhoto;
  let avatar = profilePhoto !== undefined ? profilePhoto.url : AvatarSrcUrl.place_holder;
  return JsxRuntime.jsx(AgentInfo__Jsx3.make, {
    avatar: avatar,
    size: "small",
    name: agent.displayName,
    brokerage: agent.brokerage
  });
}

let WithoutErrorBoundary = {
  make: SharedPropertyMessage$AgentInfo$WithoutErrorBoundary
};

function SharedPropertyMessage$AgentInfo(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "Sharing agent info",
    children: JsxRuntime.jsx(SharedPropertyMessage$AgentInfo$WithoutErrorBoundary, {
      sharedProperty: props.sharedProperty
    })
  });
}

let AgentInfo = {
  Fragment: Fragment,
  WithoutErrorBoundary: WithoutErrorBoundary,
  make: SharedPropertyMessage$AgentInfo
};

let convertFragment$1 = SharedPropertyMessage_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SharedPropertyMessage_sharedProperty_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SharedPropertyMessage_sharedProperty_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SharedPropertyMessage_sharedProperty_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(SharedPropertyMessage_sharedProperty_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function SharedPropertyMessage(props) {
  let match = RescriptRelay_Fragment.useFragment(SharedPropertyMessage_sharedProperty_graphql.node, convertFragment$1, props.sharedProperty);
  return JsxRuntime.jsx(SharedMessageCard.make, {
    subject: match.subject,
    message: match.message,
    agentInfo: JsxRuntime.jsx(SharedPropertyMessage$AgentInfo, {
      sharedProperty: match.sender.fragmentRefs
    })
  });
}

let make = SharedPropertyMessage;

exports.AgentInfo = AgentInfo;
exports.Fragment = Fragment$1;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
